import { Drawer as AntDrawer } from 'antd'
import type { DrawerProps } from 'antd'

export type UiDrawerSize = 'sm' | 'md' | 'lg' | 'full'

// size của AntD Drawer (default|large|số) bị thay bằng size của project.
export type UiDrawerProps = Omit<DrawerProps, 'size'> & { size?: UiDrawerSize }

// Một nơi định nghĩa width theo size, cùng ngưỡng với UiCustomModal. Không truyền size → như cũ.
const SIZE_WIDTH: Record<UiDrawerSize, string> = {
  sm: 'clamp(400px, 25vw, 480px)',
  md: 'clamp(560px, 50vw, 800px)',
  lg: 'clamp(720px, 75vw, 1200px)',
  full: '100vw',
}

// Wrapper Drawer: bọc AntD Drawer để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). width truyền tay thắng size.
export default function UiDrawer({ size, width, ...rest }: UiDrawerProps) {
  return <AntDrawer width={width ?? (size ? SIZE_WIDTH[size] : undefined)} {...rest} />
}
